import React from "react";
import { Typography } from "@mui/material";
import "./assets/home.css";
import HeroSection from "./heroSection";
import Welcome from "./welcome";
import Events from "./events";
import Pastors from "./pastors";
import Location from "../../components/horarios";
import CTA from "./nuevo";
import EscuelaBiblica from "./escuelaBiblica";

const Home: React.FC = () => {
  return (
    <>
      {/* HERO SECTION */}

      <HeroSection />

      {/* WELCOME STATEMENT */}
      <Welcome />


      {/* PASTORS SECTION */}
      <Pastors />

      {/* ERES NUEVO  */}
      <CTA />

      {/* ESCUELA BIBLICA */}
      <EscuelaBiblica />
      
      {/* LOCATION SECTION */}
      <Location />

    </>
  );
};

export default Home;
